export default {
  buttons: {
    login: 'Iniciar sesión',
  },
  feedback: {
    incorrect_code: 'El código introducido es incorrecto. Inténtalo de nuevo.',
    expired_code: 'Este código ha caducado. Solicita uno nuevo.',
    too_many_attempts: 'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
    unknown: 'Algo salió mal al verificar tu código. Inténtalo de nuevo.',
    network_error: 'No pudimos conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.',
  },
};
